import React from "react";
import About from "../components/home/about";
import Benefit from "../components/home/benefit";
import Blog from "../components/home/blog";
import Destination from "../components/home/destination";
import Experts from "../components/home/experts";
import Hero from "../components/home/hero";
import TourSection from "../components/home/place";
import Support from "../components/home/support";
import Testimonials from "../components/home/testimonials";
import Layout from "../components/layout/layout";
import {
  fetchTopRatedTours,
  fetchTopBookedTours,
  fetchTopDiscountedTours,
} from "@/redux/slices/tourSlice";

const HomePage = () => {
  return (
    <>
      <Layout>
        {/* <!-- Hero Section --> */}
        <Hero />
        {/* <!-- /Hero Section -->

    <!-- Destination Section --> */}
        <Destination />
        {/* <!-- /Destination Section -->

    <!-- Benefit Section --> */}
        <Benefit />
        {/* <!-- /Benefit Section -->

    <!-- Place Section --> */}
        {/* Top Rated Tours */}
        <TourSection
          title="Chuyến tham quan được xếp hạng hàng đầu"
          subtitle="Các tour du lịch phổ biến trên cả nước"
          toursKey="topRatedTours"
          fetchAction={fetchTopRatedTours}
          limit={4}
        />

        {/* Top Booked Tours */}
        <TourSection
          title="Chuyến tham quan được đặt nhiều nhất"
          subtitle="Các tour du lịch được yêu thích nhất"
          toursKey="topBookedTours"
          fetchAction={fetchTopBookedTours}
          limit={4}
        />

        {/* Top Discounted Tour */}
        <TourSection
          title="Chuyến tham quan giảm giá cao nhất"
          subtitle="Ưu đãi đặc biệt cho bạn"
          toursKey="topDiscountedTours"
          fetchAction={fetchTopDiscountedTours}
          limit={4} // Chỉ hiển thị 1 tour có discount cao nhất
        />
        {/* <!-- /Place Section -->

    <!-- Support Section --> */}
        <Support />
        {/* <!-- /Support Section -->

    <!-- About Section --> */}
        <About />
        {/* <!-- /About Section -->

    <!-- Testimonials Section --> */}
        <Testimonials />
        {/* <!-- /Testimonials Section -->

    <!-- Experts Section --> */}
        <Experts />
        {/* <!-- /Experts Section -->

    <!-- Blog Section --> */}
        <Blog />
        {/* <!-- /Blog Section --> */}

        {/* <!-- Cursor --> */}
        <div className="xb-cursor tx-js-cursor">
          <div className="xb-cursor-wrapper">
            <div className="xb-cursor--follower xb-js-follower"></div>
          </div>
        </div>
        {/* <!-- /Cursor --> */}

        <div className="back-to-top">
          <a
            className="back-to-top-icon align-items-center justify-content-center d-flex"
            href="#top"
          >
            <i className="fa-solid fa-arrow-up"></i>
          </a>
        </div>
      </Layout>
    </>
  );
};

export default HomePage;
